var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuInternalstaff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.131,
    height: 22.129,
    viewBox: "0 0 22.131 22.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_917",
    "data-name": "Rectangle 917",
    width: 22.131,
    height: 22.129,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4071",
    "data-name": "Group 4071",
    transform: "translate(0 -0.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493",
    transform: "translate(0 0.436)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M64.993,0a4.781,4.781,0,0,1,4.752,4.77A4.764,4.764,0,1,1,60.218,4.7,4.781,4.781,0,0,1,64.993,0m-.021,1.616a3.107,3.107,0,0,0-3.114,3.156A3.123,3.123,0,0,0,68.1,4.755a3.108,3.108,0,0,0-3.132-3.138",
    transform: "translate(-55.494 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M5.1,150.319H.883A.788.788,0,0,1,0,149.438c0-.51.005-1.019,0-1.529a7.107,7.107,0,0,1,5.587-6.94,6.326,6.326,0,0,1,1.391-.155c1.093.006,2.186,0,3.279,0a.808.808,0,1,1-.009,1.612c-.986,0-1.972-.007-2.959,0a5.617,5.617,0,0,0-3.031.807,5.347,5.347,0,0,0-2.608,4.317c-.021.279-.029.558-.044.836-.013.246.059.323.315.322,1.874-.011,3.747-.006,5.621-.006.6,0,1.2,0,1.8,0a.807.807,0,1,1,0,1.611q-2.12,0-4.241,0",
    transform: "translate(0 -129.768)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 8.508,
    height: 2.32,
    rx: 1.16,
    transform: "translate(13.924 21.318) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    width: 8.508,
    height: 2.32,
    rx: 1.16,
    transform: "translate(19.336 18.225) rotate(180)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuInternalstaff);
export default __webpack_public_path__ + "static/media/icon_menu_internalstaff.38f02f7b8ae5a2c7f35f2eff8bf35070.svg";
export { ForwardRef as ReactComponent };